import React from 'react'
import { Typography } from "@mui/material"

export const Span = ({ children, sx, ...props })  => {
  return (
    <Typography variant="inherit" component="span" sx={sx} {...props}>
      {children}
    </Typography>
  )
}

export default Span